import { useSelectedTrial } from 'src/features/auth/context'
import { Trial } from 'src/features/trial/types'
import { useMutation, UseMutationOption } from 'src/hooks/use-mutation'
import { createApiClient } from 'src/lib/api-client'

const sendTestEmail = async ({
  trialUid,
  email,
}: {
  trialUid: Trial['uid']
  email: string
}): Promise<void> => {
  const res = await createApiClient({
    path: '/trials/{trial_uid}/explanation_patients/test_email',
    httpMethod: 'post',
    params: {
      paths: {
        trial_uid: trialUid,
      },
      body: {
        emailAddress: email,
      },
    },
  }).request()

  if (res.result === 'error') {
    throw new Error(res.error.data.message)
  }
}

export const useSendTestEmail = (option?: UseMutationOption<void>) => {
  const { selectedTrial } = useSelectedTrial()
  return useMutation(
    ({ email }: { email: string }) =>
      sendTestEmail({
        trialUid: selectedTrial.uid,
        email,
      }),
    option,
  )
}
